var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700pt",
    height: "700pt",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "t",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.766-1.125c-.96875.5-1.9805.875-3.0312 1.125-1.043.25781-2.1367.39062-3.2812.39062-3.3984.0-6.0898-.94531-8.0781-2.8438-1.9922-1.9062-2.9844-4.4844-2.9844-7.7344.0-3.2578.99219-5.8359 2.9844-7.7344 1.9883-1.9062 4.6797-2.8594 8.0781-2.8594 1.1445.0 2.2383.13281 3.2812.39062 1.0508.25 2.0625.625 3.0312 1.125v4.2188c-.98047-.65625-1.9453-1.1406-2.8906-1.4531-.94922-.3125-1.9492-.46875-3-.46875-1.875.0-3.3516.60547-4.4219 1.8125-1.0742 1.1992-1.6094 2.8555-1.6094 4.9688.0 2.1055.53516 3.7617 1.6094 4.9688 1.0703 1.1992 2.5469 1.7969 4.4219 1.7969 1.0508.0 2.0508-.14844 3-.45312.94531-.3125 1.9102-.80078 2.8906-1.4688z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "d",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.734-11.141c-.4375-.19531-.87109-.34375-1.2969-.4375-.41797-.10156-.83984-.15625-1.2656-.15625-1.2617.0-2.2305.40625-2.9062 1.2188-.67969.80469-1.0156 1.9531-1.0156 3.4531v7.0625H2.3591v-15.312h4.8906v2.5156c.625-1 1.3438-1.7266 2.1562-2.1875.82031-.46875 1.8008-.70312 2.9375-.70312.16406.0.34375.011719.53125.03125.19531.011719.47656.039062.84375.078125z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "a",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.641-7.7031v1.4062H6.188c.125 1.1484.53906 2.0078 1.25 2.5781.70703.57422 1.7031.85938 2.9844.85938 1.0312.0 2.082-.14844 3.1562-.45312 1.082-.3125 2.1914-.77344 3.3281-1.3906v3.7656c-1.1562.4375-2.3125.76562-3.4688.98438-1.1562.22656-2.3125.34375-3.4688.34375-2.7734.0-4.9297-.70312-6.4688-2.1094-1.5312-1.4062-2.2969-3.3789-2.2969-5.9219.0-2.5.75391-4.4609 2.2656-5.8906 1.5078-1.4375 3.582-2.1562 6.2188-2.1562 2.4062.0 4.332.73047 5.7812 2.1875 1.4453 1.4492 2.1719 3.3828 2.1719 5.7969zm-5.0312-1.625c0-.92578-.27344-1.6719-.8125-2.2344-.54297-.57031-1.25-.85938-2.125-.85938-.94922.0-1.7188.26562-2.3125.79688s-.96484 1.2969-1.1094 2.2969z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "c",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.2188-6.8906c-1.0234.0-1.793.17188-2.3125.51562-.51172.34375-.76562.85547-.76562 1.5312.0.625.20703 1.1172.625 1.4688.41406.34375.98828.51562 1.7188.51562.92578.0 1.7031-.32812 2.3281-.98438.63281-.66406.95312-1.4922.95312-2.4844v-.5625zm7.4688-1.8438V0h-4.9219v-2.2656c-.65625.92969-1.3984 1.6055-2.2188 2.0312-.82422.41406-1.8242.625-3 .625-1.5859.0-2.8711-.45703-3.8594-1.375-.99219-.92578-1.4844-2.1289-1.4844-3.6094.0-1.7891.61328-3.1016 1.8438-3.9375 1.2383-.84375 3.1797-1.2656 5.8281-1.2656h2.8906v-.39062c0-.76953-.30859-1.332-.92188-1.6875-.61719-.36328-1.5703-.54688-2.8594-.54688-1.0547.0-2.0312.10547-2.9375.3125-.89844.21094-1.7305.52344-2.5.9375v-3.7344c1.0391-.25 2.0859-.44141 3.1406-.57812 1.0625-.13281 2.125-.20312 3.1875-.20312 2.7578.0 4.75.54688 5.9688 1.6406 1.2266 1.0859 1.8438 2.8555 1.8438 5.3125z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "b",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.7031-19.656v4.3438H12.75v3.5H7.7031v6.5c0 .71094.14062 1.1875.42188 1.4375s.83594.375 1.6719.375h2.5156v3.5h-4.1875c-1.9375.0-3.3125-.39844-4.125-1.2031-.80469-.8125-1.2031-2.1797-1.2031-4.1094v-6.5h-2.4219v-3.5h2.4219v-4.3438z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "k",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.766-13.078v-8.2031h4.9219v21.281H12.766v-2.2188c-.66797.90625-1.4062 1.5703-2.2188 1.9844s-1.7578.625-2.8281.625c-1.8867.0-3.4336-.75-4.6406-2.25-1.2109-1.5-1.8125-3.4258-1.8125-5.7812.0-2.3633.60156-4.2969 1.8125-5.7969 1.207-1.5 2.7539-2.25 4.6406-2.25 1.0625.0 2 .21484 2.8125.64062.82031.42969 1.5664 1.0859 2.2344 1.9688zM9.5472-3.1561c1.0391.0 1.8359-.37891 2.3906-1.1406.55078-.76953.82812-1.8828.82812-3.3438.0-1.457-.27734-2.5664-.82812-3.3281-.55469-.76953-1.3516-1.1562-2.3906-1.1562-1.043.0-1.8398.38672-2.3906 1.1562-.55469.76172-.82812 1.8711-.82812 3.3281.0 1.4609.27344 2.5742.82812 3.3438.55078.76172 1.3477 1.1406 2.3906 1.1406z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "j",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.5-3.1562c1.0508.0 1.8516-.37891 2.4062-1.1406.55078-.76953.82812-1.8828.82812-3.3438.0-1.457-.27734-2.5664-.82812-3.3281-.55469-.76953-1.3555-1.1562-2.4062-1.1562-1.0547.0-1.8594.38672-2.4219 1.1562-.55469.77344-.82812 1.8828-.82812 3.3281.0 1.4492.27344 2.5586.82812 3.3281.5625.77344 1.3672 1.1562 2.4219 1.1562zm-3.25-9.9219c.67578-.88281 1.4219-1.5391 2.2344-1.9688.82031-.42578 1.7656-.64062 2.8281-.64062 1.8945.0 3.4453.75 4.6562 2.25 1.207 1.5 1.8125 3.4336 1.8125 5.7969.0 2.3555-.60547 4.2812-1.8125 5.7812-1.2109 1.5-2.7617 2.25-4.6562 2.25-1.0625.0-2.0078-.21094-2.8281-.625-.8125-.42578-1.5586-1.0859-2.2344-1.9844v2.2188H2.3594v-21.281H7.25z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "i",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.34375-15.312h4.8906l4.125 10.391 3.5-10.391h4.8906l-6.4375 16.766c-.64844 1.6953-1.4023 2.8828-2.2656 3.5625-.86719.6875-2 1.0312-3.4062 1.0312h-2.8438V2.8289h1.5312c.83203.0 1.4375-.13672 1.8125-.40625.38281-.26172.67969-.73047.89062-1.4062l.14062-.42188z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "h",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.047-11.359c1.1016.0 1.8945-.20312 2.375-.60938.47656-.41406.71875-1.0938.71875-2.0312.0-.92578-.24219-1.5859-.71875-1.9844-.48047-.40625-1.2734-.60938-2.375-.60938H7.8282v5.2344zM7.8282-7.7184v7.7188h-5.25v-20.406h8.0312c2.6875.0 4.6562.45312 5.9062 1.3594 1.2578.89844 1.8906 2.3203 1.8906 4.2656.0 1.3555-.32812 2.4648-.98438 3.3281-.64844.86719-1.625 1.5-2.9375 1.9062.71875.16797 1.3594.54297 1.9219 1.125.57031.57422 1.1484 1.4492 1.7344 2.625l2.8594 5.7969h-5.6094l-2.4844-5.0781c-.5-1.0195-1.0117-1.7109-1.5312-2.0781-.51172-.375-1.1953-.5625-2.0469-.5625z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "g",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.547-12.766c.61328-.94531 1.3477-1.6719 2.2031-2.1719.85156-.5 1.7891-.75 2.8125-.75 1.7578.0 3.0977.54688 4.0156 1.6406.92578 1.0859 1.3906 2.6562 1.3906 4.7188v9.3281h-4.9219v-7.9844-.35938c.007813-.13281.015625-.32031.015625-.5625.0-1.082-.16406-1.8633-.48438-2.3438-.3125-.48828-.82422-.73438-1.5312-.73438-.92969.0-1.6484.38672-2.1562 1.1562-.51172.76172-.77344 1.8672-.78125 3.3125v7.5156h-4.9219v-7.9844c0-1.6953-.14844-2.7852-.4375-3.2656-.29297-.48828-.8125-.73438-1.5625-.73438-.9375.0-1.6641.38672-2.1719 1.1562-.51172.76172-.76562 1.8594-.76562 3.2969v7.5312h-4.9219v-15.312h4.9219v2.2344c.60156-.86328 1.2891-1.5156 2.0625-1.9531.78125-.4375 1.6406-.65625 2.5781-.65625 1.0625.0 2 .25781 2.8125.76562.8125.51172 1.4258 1.2305 1.8438 2.1562z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "s",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.312-14.828v3.7188c-1.043-.4375-2.0547-.76562-3.0312-.98438-.98047-.21875-1.9023-.32812-2.7656-.32812-.92969.0-1.6211.11719-2.0781.34375-.44922.23047-.67188.58984-.67188 1.0781.0.38672.17188.68359.51562.89062.34375.21094.95703.36719 1.8438.46875l.85938.125c2.5078.32422 4.1953.85156 5.0625 1.5781.86328.73047 1.2969 1.8711 1.2969 3.4219.0 1.6367-.60547 2.8672-1.8125 3.6875-1.1992.8125-2.9922 1.2188-5.375 1.2188-1.0234.0-2.0742-.078125-3.1562-.23438-1.0742-.15625-2.1797-.39453-3.3125-.71875v-3.7188c.96875.48047 1.9609.83984 2.9844 1.0781 1.0312.23047 2.0781.34375 3.1406.34375.95703.0 1.6758-.12891 2.1562-.39062.47656-.26953.71875-.66406.71875-1.1875.0-.4375-.16797-.75781-.5-.96875-.33594-.21875-.99609-.38281-1.9844-.5l-.85938-.10938c-2.1797-.26953-3.7031-.77344-4.5781-1.5156-.875-.73828-1.3125-1.8594-1.3125-3.3594.0-1.625.55078-2.8281 1.6562-3.6094 1.1133-.78906 2.8203-1.1875 5.125-1.1875.89453.0 1.8359.074219 2.8281.21875 1 .13672 2.082.35156 3.25.64062z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "f",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.75-9.3281V0h-4.9219v-7.1094c0-1.3438-.03125-2.2656-.09375-2.7656s-.16797-.86719-.3125-1.1094c-.1875-.3125-.44922-.55469-.78125-.73438-.32422-.17578-.69531-.26562-1.1094-.26562-1.0234.0-1.8242.39844-2.4062 1.1875-.58594.78125-.875 1.8711-.875 3.2656v7.5312H2.3594v-21.281H7.25v8.2031c.73828-.88281 1.5195-1.5391 2.3438-1.9688.83203-.42578 1.75-.64062 2.75-.64062 1.7695.0 3.1133.54688 4.0312 1.6406.91406 1.0859 1.375 2.6562 1.375 4.7188z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "r",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.422-21.281v3.2188H9.7189c-.6875.0-1.1719.125-1.4531.375-.27344.25-.40625.6875-.40625 1.3125v1.0625h4.1875v3.5h-4.1875v11.812h-4.8906v-11.812h-2.4375v-3.5h2.4375v-1.0625c0-1.6641.46094-2.8984 1.3906-3.7031.92578-.80078 2.3672-1.2031 4.3281-1.2031z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "e",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.6406-12.188c-1.0859.0-1.9141.39062-2.4844 1.1719-.57422.78125-.85938 1.9062-.85938 3.375s.28516 2.5938.85938 3.375c.57031.77344 1.3984 1.1562 2.4844 1.1562 1.0625.0 1.875-.38281 2.4375-1.1562.57031-.78125.85938-1.9062.85938-3.375s-.28906-2.5938-.85938-3.375c-.5625-.78125-1.375-1.1719-2.4375-1.1719zm0-3.5c2.6328.0 4.6914.71484 6.1719 2.1406 1.4766 1.418 2.2188 3.3867 2.2188 5.9062.0 2.5117-.74219 4.4805-2.2188 5.9062-1.4805 1.418-3.5391 2.125-6.1719 2.125-2.6484.0-4.7148-.70703-6.2031-2.125-1.4922-1.4258-2.2344-3.3945-2.2344-5.9062.0-2.5195.74219-4.4883 2.2344-5.9062 1.4883-1.4258 3.5547-2.1406 6.2031-2.1406z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "q",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.5781-20.406h5.875l7.4219 14v-14h4.9844V0h-5.875L7.5625-14V0H2.5781z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "p",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.1875-5.9688v-9.3438h4.9219v1.5312c0 .83594-.007813 1.875-.015625 3.125-.011719 1.25-.015625 2.0859-.015625 2.5.0 1.2422.03125 2.1328.09375 2.6719.070313.54297.17969.93359.32812 1.1719.20703.32422.47266.57422.79688.75.32031.16797.69141.25 1.1094.25 1.0195.0 1.8203-.39062 2.4062-1.1719.58203-.78125.875-1.8672.875-3.2656v-7.5625h4.8906v15.312h-4.8906v-2.2188c-.74219.89844-1.5234 1.5586-2.3438 1.9844-.82422.41406-1.7344.625-2.7344.625-1.7617.0-3.1055-.53906-4.0312-1.625-.92969-1.082-1.3906-2.6602-1.3906-4.7344z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "o",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.75-9.3281V0h-4.9219v-7.1406c0-1.3203-.03125-2.2344-.09375-2.7344s-.16797-.86719-.3125-1.1094c-.1875-.3125-.44922-.55469-.78125-.73438-.32422-.17578-.69531-.26562-1.1094-.26562-1.0234.0-1.8242.39844-2.4062 1.1875-.58594.78125-.875 1.8711-.875 3.2656v7.5312H2.3594v-15.312H7.25v2.2344c.73828-.88281 1.5195-1.5391 2.3438-1.9688.83203-.42578 1.75-.64062 2.75-.64062 1.7695.0 3.1133.54688 4.0312 1.6406.91406 1.0859 1.375 2.6562 1.375 4.7188z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "n",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.5781-20.406h8.7344c2.5938.0 4.582.57812 5.9688 1.7344 1.3945 1.1484 2.0938 2.7891 2.0938 4.9219.0 2.1367-.69922 3.7812-2.0938 4.9375-1.3867 1.1562-3.375 1.7344-5.9688 1.7344H7.8281v7.0781h-5.25zm5.25 3.8125v5.7031H10.75c1.0195.0 1.8047-.25 2.3594-.75.5625-.5.84375-1.2031.84375-2.1094.0-.91406-.28125-1.6172-.84375-2.1094-.55469-.48828-1.3398-.73438-2.3594-.73438z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "m",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.3594-15.312H7.25v15.031c0 2.0508-.49609 3.6172-1.4844 4.7031-.98047 1.082-2.4062 1.625-4.2812 1.625H-.9375V2.8283h.85938c.92578.0 1.5625-.21094 1.9062-.625.35156-.41797.53125-1.2461.53125-2.4844zm0-5.9688H7.25v4H2.3594z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "l",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.719-14.828v3.9844c-.65625-.45703-1.3242-.79688-2-1.0156-.66797-.21875-1.3594-.32812-2.0781-.32812-1.3672.0-2.4336.40234-3.2031 1.2031-.76172.79297-1.1406 1.9062-1.1406 3.3438.0 1.4297.37891 2.543 1.1406 3.3438.76953.79297 1.8359 1.1875 3.2031 1.1875.75781.0 1.4844-.10938 2.1719-.32812.6875-.22656 1.3203-.56641 1.9062-1.0156v4c-.76172.28125-1.5391.48828-2.3281.625-.78125.14453-1.5742.21875-2.375.21875-2.7617.0-4.9219-.70703-6.4844-2.125-1.5547-1.4141-2.3281-3.3828-2.3281-5.9062.0-2.5312.77344-4.5039 2.3281-5.9219 1.5625-1.4141 3.7227-2.125 6.4844-2.125.80078.0 1.5938.074219 2.375.21875.78125.13672 1.5547.35156 2.3281.64062z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m232.4 224h67.199v11.199H232.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m551.6 520.8v-425.6h-67.203v-56h-232.62l-103.38 105.5v308.9h56v67.199zm-11.203-414.4v403.2h-324.8v-56h268.8V106.4zm-291.2-48.605v87.809h-86.016zm-89.598 384.61v-285.6h100.8v-106.4h212.8v392z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m232.4 291.2h168v11.199h-168z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m232.4 358.4h168v11.199h-168z"
  }), /*#__PURE__*/React.createElement("use", {
    x: 70,
    y: 644,
    xlinkHref: "#t"
  }), /*#__PURE__*/React.createElement("use", {
    x: 90.550781,
    y: 644,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 104.359375,
    y: 644,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 123.347656,
    y: 644,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 142.242188,
    y: 644,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 155.628906,
    y: 644,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 174.617188,
    y: 644,
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("use", {
    x: 204.410156,
    y: 644,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("use", {
    x: 224.453125,
    y: 644,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("use", {
    x: 252.453125,
    y: 644,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    x: 274.011719,
    y: 644,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 292.90625,
    y: 644,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    x: 322.082031,
    y: 644,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 341.070312,
    y: 644,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("use", {
    x: 357.738281,
    y: 644,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 377.671875,
    y: 644,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 70,
    y: 672,
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("use", {
    x: 82.183594,
    y: 672,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 95.992188,
    y: 672,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 115.226562,
    y: 672,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    x: 154.152344,
    y: 672,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 167.535156,
    y: 672,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 187.46875,
    y: 672,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 216.207031,
    y: 672,
    xlinkHref: "#q"
  }), /*#__PURE__*/React.createElement("use", {
    x: 239.640625,
    y: 672,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 258.878906,
    y: 672,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 278.8125,
    y: 672,
    xlinkHref: "#o"
  }), /*#__PURE__*/React.createElement("use", {
    x: 308.492188,
    y: 672,
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("use", {
    x: 329.015625,
    y: 672,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 342.820312,
    y: 672,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 362.058594,
    y: 672,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("use", {
    x: 371.65625,
    y: 672,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 390.648438,
    y: 672,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("use", {
    x: 407.242188,
    y: 672,
    xlinkHref: "#b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/documentIcon.0522bada5cfdc906e35736b14fb6c437.svg";
export { ForwardRef as ReactComponent };